import './setupConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { loadAppConfig } from './config/appConfig';
import { devError } from './utils/devLog';

// También manejar errores no capturados del mismo tipo
window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

function initClarity(projectId: string) {
  window.clarity = window.clarity || ((...args: any[]) => {
    ((window.clarity as any).q = (window.clarity as any).q || []).push(args);
  });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.clarity.ms/tag/${projectId}`;
  document.head.appendChild(s);
}

// Cargar configuración antes de renderizar la aplicación
loadAppConfig().then((config) => {
  if (config.clarityProjectId) {
    initClarity(config.clarityProjectId);
  }
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}).catch((error) => {
  devError('Error al cargar la configuración:', error);
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
});
